export const formatTime = (dateString?: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const startOfDayTs = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

export const formatDateLabel = (date: Date) => {
  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(date);
};

export const getUnreadBadgeText = (unreadCount?: number): string | null => {
  if (!unreadCount || unreadCount <= 0) return null;
  if (unreadCount > 9) return '9+';
  return String(unreadCount);
};
